import updateAllTextures from "./update-all-textures";
import { DefaultLoadingManager, Object3D } from "three";
import { cooldown } from "../control-flow/cooldown";
import { overloadHandlerFunction } from "../control-flow/overload-handler-fuction";
import timer from "../animation/timer";


/**
 * This uses the DefaultLoadingManager to set the needsUpdate flag on every
 * texture in the scene after every onLoad event plus a a 16 millisecond
 * cooldown period. The cooldown ensures that multiple load events don't cause
 * too much churn with updating the textures.
 */
export const fixSurfaceProRendering = (root: Object3D) => {
    overloadHandlerFunction(DefaultLoadingManager, 'onLoad', () => {
        cooldown(16, root, () => {
            updateAllTextures(root);
            timer(1000).then(() => updateAllTextures(root));
            timer(3000).then(() => updateAllTextures(root));
        });
    });
}
export default fixSurfaceProRendering;
